import { useQuery } from "@tanstack/react-query";
import { fetchPublicConfig, type PublicConfig } from "@/api/config";

/**
 * Public client configuration (Stripe pk + the Google Maps / Smarty keys for the
 * recipient address flow). Served by `GET /api/config`, not inlined into the bundle.
 * Cached app-wide and never refetched during a session (the keys don't change).
 */
export function usePublicConfig() {
  return useQuery<PublicConfig>({
    queryKey: ["public-config"],
    queryFn: fetchPublicConfig,
    staleTime: Number.POSITIVE_INFINITY,
  });
}
